import { Component, inject } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { RouterLink } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { TranslateModule } from "@ngx-translate/core";
import { MatMenuModule } from "@angular/material/menu";
import { DomainService } from "../../../../../../../shared/src/lib/services/domain.service";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-m-header",
  imports: [MatExpansionModule, MatIconModule, RouterLink, MatButtonModule, MatSidenavModule, TranslateModule, MatMenuModule, MatButtonModule, AsyncPipe],
  templateUrl: "./m-header.component.html",
  styleUrl: "./m-header.component.scss",
})
export class MHeaderComponent {
  navService = inject(NavService);
  domainService = inject(DomainService);
}
